export { default as Pagination } from './Pagination';
export { default as Control } from './PageControl';
export { default as Ellipsis } from './Ellipsis';
export { default as Page } from './Page';
export { default as List } from './PageList';
export { default as Link } from './PageLink';


// WEBPACK FOOTER //
// ./src/components/Pagination/index.ts